import { blockAdapterBase } from 'volto-ministerio-publico-federal/helpers/BlockAdapter/BlockAdapter';

export const HomeBannerBlockDataAdapter: typeof blockAdapterBase = ({
  block,
  data,
  id,
  onChangeBlock,
  value,
}) => {
  blockAdapterBase(block, data, id, onChangeBlock, value, 'items');
};
